
import { useI18n } from "vue-i18n";
import { defineComponent, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import defray from "@/api/defray";
import useClipboard from "vue-clipboard3";
import { Field, Button, Cell, CellGroup, CountDown, Toast, Loading, Icon } from "vant";
import { CurrencyList, CryptoInfoObject, FormatDateZone } from "./interface";
import Types from "./types.vue";
export default defineComponent({
  name: "crypto",
  props: ["type", "info", "showCrypto", "showFiat"],
  emits: ["update:modelValue", "clearRefRate"],
  components: {
    VueQrcode,
    Types,
    [Field.name]: Field,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Icon.name]: Icon
  },
  setup(props, ctx) {
    const route = useRoute();
    const { t } = useI18n();
    const loaded = ref(false);
    const type = ref(ctx.attrs.modelValue || 0);
    const dev = process.env.VUE_APP_BUILD_ENV;

    watch(
      () => type.value,
      (a, b) => {
        type.value = a;
        ctx.emit("update:modelValue", a);
      }
    );

    onMounted(() => {
      getOrderDetail();
    });

    const SplitNumber = number => {
      let data = number.toString().split("");
      let n1 = 0,
        n2 = 0;
      if (data.length == 2) {
        n1 = data[0];
        n2 = data[1];
      } else if (data.length == 1) {
        n2 = data[0];
      }
      return [n1, n2];
    };

    const result = ref(<CryptoInfoObject>{
      cash_currency_config_list: [],
      crypto_currency_config_list: [],
      amount: 0,
      cancel_url: "",
      currency: "",
      description: "",
      expires_at: "",
      expires_in: 0,
      name: "",
      order_no: "",
      out_order_no: "",
      out_user_id: "",
      out_user_name: "",
      payment_url: "",
      redirect_url: "",
      order_status: "",
      extend: {}
    });

    const getOrderDetail = async () => {
      // const loadingToast = Toast({
      //   message: "",
      //   type: "loading",
      //   duration: 0,
      //   overlay: true,
      //   overlayStyle: {
      //     backgroundColor: "rgba(0, 0, 0, 0)"
      //   }
      // });
      // const res = await defray.getPayIn();
      const res = props.info;
      // loadingToast?.close();
      if (res?.code == 200) {
        result.value = res?.data;
        result.value.extend = Object.assign(
          res?.data?.crypto_order_detail || {},
          result.value.extend
        );
        if (res?.data?.crypto_order_detail) {
          ctx.emit("update:modelValue", 0);
          switch (result.value?.extend?.order_status) {
            case "PENDING":
              steps.value = 2;
              setTimeout(() => {
                getStatus();
              }, 3000);
              break;
            case "SUCCESS":
              steps.value = 4;
              setTimeout(() => {
                if (result.value?.redirect_url) {
                  window.location.href = result.value?.redirect_url;
                }
              }, 1000);
              break;
            case "FAIL":
            case "CANCEL":
              steps.value = 4;
              if (result.value?.cancel_url) {
                window.location.href = result.value?.cancel_url;
              }
              break;
          }
        } else {
          if (res?.data?.cash_order_detail) {
            ctx.emit("update:modelValue", 1);
          } else {
            steps.value = 1;
            if (result.value.crypto_currency_config_list?.length) {
              setCheckCurrency(result.value.crypto_currency_config_list[0]);
            }
          }
        }
      } else {
        res?.message &&
          Toast({
            message: res?.message,
            overlay: false,
            duration: 2000
          });
      }
    };

    // 选择币种
    const checkCurrency = ref(<CurrencyList>{});
    const setCheckCurrency = item => {
      checkCurrency.value = item;
      if (item?.payment_type_list.length) {
        setCheckChain(item?.payment_type_list[0]);
      }
    };
    const checkChain = ref("");
    const setCheckChain = value => {
      checkChain.value = value;
    };

    // 轮询获取状态
    const getStatus = async () => {
      const res = await defray.getPayIn();
      if (res?.code == 200) {
        let data = res?.data;
        if (data?.crypto_order_detail) {
          result.value.extend = Object.assign(result.value.extend, data?.crypto_order_detail || {});
          switch (result.value?.extend?.order_status) {
            case "PENDING":
              setTimeout(() => {
                getStatus();
              }, 3000);
              break;
            case "SUCCESS":
              steps.value = 4;
              setTimeout(() => {
                if (result.value?.redirect_url) {
                  window.location.href = result.value?.redirect_url;
                }
              }, 1000);
              break;
            case "FAIL":
            case "CANCEL":
              steps.value = 4;
              if (data?.cancel_url) {
                window.location.href = data?.cancel_url;
              }
              break;
          }
        }
      }
    };

    const { toClipboard } = useClipboard();
    const copy = async (text: string) => {
      try {
        await toClipboard(text);
        Toast({
          message: t("defray.copied"),
          overlay: false,
          duration: 800
        });
      } catch (e) {
        console.error(e);
      }
    };

    // 下一步
    const steps = ref(1);
    const next = () => {
      if (steps.value == 1) {
        if (!checkCurrency.value.currency || !checkChain.value) {
          return;
        }
        createOrder();
      }
      if (steps.value == 2) {
        steps.value++;
      }
    };

    // 下单
    const createOrder = async () => {
      const loadingToast = Toast({
        message: "",
        type: "loading"
      });
      const res = await defray.postCryptoPayIn({
        currency: checkCurrency.value.currency,
        payment_type: checkChain.value
      });
      loadingToast?.close();
      if (res?.code == 200) {
        getStatus();
        ctx.emit("clearRefRate");
        result.value.extend = Object.assign(
          res?.data?.crypto_order_detail,
          result.value.extend || {}
        );
        steps.value++;
      } else {
        res?.message &&
          Toast({
            message: res?.message,
            overlay: false,
            duration: 4000
          });
      }
    };

    // 取消订单
    const cancelOrder = async () => {
      const loadingToast = Toast({
        message: "",
        type: "loading"
      });
      const res = await defray.cancelOrder(result.value?.extend?.order_no);
      loadingToast?.close();
      if (res?.code == 200) {
        getStatus();
      }
    };

    // 倒计时结束
    const isFinish = ref(false);
    const finish = () => {
      isFinish.value = true;
    };

    // 重定向
    const redirect = () => {
      window.location.href = result?.value?.redirect_url;
    };

    // 关闭页面
    const cancelPayment = () => {
      // window.location.href = result?.value.cancel_url;
      if (window["win"]) {
        window["win"].close();
      } else {
        const winds = window.open("about:blank", "_self");
        winds?.close();
      }
    };

    return {
      dev,
      FormatDateZone,
      type,
      SplitNumber,
      copy,
      loaded,
      result,

      isFinish,
      finish,

      checkCurrency,
      setCheckCurrency,

      checkChain,
      setCheckChain,

      steps,
      next,
      cancelOrder,
      cancelPayment,
      redirect
    };
  }
});
